
import Vue from "vue";
import { Component, Prop, Emit } from "vue-property-decorator";
import DepartmentRecord from "./DepartmentRecord";

@Component
export default class CellOperations extends Vue {
  @Prop()
  record!: DepartmentRecord;

  get NewRow() {
    if (this.record) {
      return this.record.newRowRecord;
    }
    return false;
  }
  acceptEdit() {
    this.$emit("accept");
  }
  cancelEdit() {
    this.$emit("cancel");
  }

  deleteDepartment() {
    this.$emit("delete");
  }
}
